import PARENT from '../types';

export const SET_PDS = `${PARENT}/SET_PDS`;
